import { motion } from "framer-motion";
import { Clock, MapPin, CreditCard, MessageCircle } from "lucide-react";

const items = [
  {
    icon: Clock,
    label: "Horaires",
    main: "Sur rendez-vous",
    sub: "Du lundi au samedi",
    href: "tel:+33767396699",
    test: "footer-action-hours",
  },
  {
    icon: MapPin,
    label: "Retrait boutique",
    main: "17 rue de Pierrefonds",
    sub: "Ouvrir dans Maps →",
    href: "https://www.google.com/maps/dir/?api=1&destination=17+rue+de+Pierrefonds+60200+Compi%C3%A8gne",
    test: "footer-action-maps",
    external: true,
  },
  {
    icon: CreditCard,
    label: "Paiement",
    main: "4× sans frais",
    sub: "Disponible sur tous les handpans",
    href: "#location",
    test: "footer-action-payment",
  },
  {
    icon: MessageCircle,
    label: "WhatsApp / Tel",
    main: "07 67 39 66 99",
    sub: "Réponse rapide",
    href: "https://wa.me/33767396699",
    test: "footer-action-whatsapp",
    external: true,
  },
];

export default function FooterActions() {
  return (
    <section
      className="relative py-16 md:py-20 px-6 md:px-12 lg:px-20 bg-cream border-t border-ink/10"
      data-testid="footer-actions"
    >
      <div className="max-w-[1400px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-10"
        >
          <span className="text-[10px] uppercase tracking-[0.3em] text-ink/55">
            Tout pour passer à l'action
          </span>
          <h3 className="mt-3 font-serif text-3xl md:text-4xl text-ink font-light">
            Une dernière chose <span className="italic-serif text-terracotta">avant de partir.</span>
          </h3>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.a
                key={it.label}
                href={it.href}
                target={it.external ? "_blank" : undefined}
                rel={it.external ? "noreferrer" : undefined}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.1 }}
                whileHover={{ y: -4 }}
                className="group flex flex-col items-start p-6 md:p-7 rounded-2xl bg-sand border border-ink/8 hover:border-terracotta/40 hover:bg-cream transition-all duration-500"
                data-testid={it.test}
              >
                <div className="w-11 h-11 rounded-full bg-cream group-hover:bg-terracotta flex items-center justify-center mb-4 transition-colors">
                  <Icon
                    size={18}
                    className="text-terracotta group-hover:text-cream transition-colors"
                  />
                </div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-ink/55 mb-1">
                  {it.label}
                </div>
                <div className="font-serif text-lg md:text-xl text-ink leading-tight">
                  {it.main}
                </div>
                <div className="text-xs text-ink/55 mt-1.5">{it.sub}</div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
